// extracted by mini-css-extract-plugin
module.exports = {"badge":"HeaderBadge_badge__8Ue7S"};